import {doppeActionTypeDefineViewerMetadata} from '../../client-server-common/doppe-action-types/doppe-action-type';
import {doppeActionTypeDownloadFile} from './doppe-action-type-download-file';
import {DoppeActionGoalType} from '../../client-server-common/doppe-action-types/doppe-action-type';
import {
    doppeViewerDownloadFileResolveOnClick,
} from '../../components/doppe-viewer-buy-or-claim-download-modal/doppe-viewer-download-file-on-click';
import {DoppeViewerLang} from '../../client-server-common/doppe-viewer/doppe-viewer-lang';
import {DoppeViewerAppIconDownloadMedium} from '../../components/doppe-viewer-icons/doppe-viewer-icons';

/**
 * Viewer for the top-level Download File action. The action renders as a
 * single CTA button (the framework uses `getActionButtonProps` to build it,
 * with the action's outer `name` as the button label). Clicking delegates to
 * the shared `doppeViewerDownloadFileResolveOnClick` so the free/paid flow,
 * preview-mode handling, payments-disabled gate, and Wix Checkout URL tagging
 * stay identical to the legacy `DoppeActionCTAType.DownloadFile` CTA option.
 *
 * Localized strings (`freeDownloadGenericErrorMessage`,
 * `digitalDownloadFallbackItemTypeLabel`) and `viewerLang` are passed as
 * English fallbacks because `getActionButtonProps` runs outside React and
 * cannot call `useDoppeViewerLocales` / `useDoppeViewerLang`. The CTA caller
 * resolves them via hooks. TODO(devzai): plumb the viewer locales / lang into
 * `IDoppeViewerActionContext` so both callers can use the same accessor.
 */
export const doppeActionTypeDownloadFileViewer = doppeActionTypeDefineViewerMetadata(doppeActionTypeDownloadFile, {

    getActionButtonProps: actionContext => {

        const action = actionContext.action;
        const settings = action.settings;

        const handleDownloadClick = doppeViewerDownloadFileResolveOnClick({
            fileId: settings.fileId,
            fileName: settings.fileName,
            paymentSettings: settings.paymentSettings,
            actionContext: actionContext,
            viewerLang: DoppeViewerLang.English,
            checkoutModalTitle: action.name,
            freeDownloadGenericErrorMessage: "Couldn't start the download. Please try again.",
            digitalDownloadFallbackItemTypeLabel: 'Digital download',
        });

        return {
            onClick: () => {
                actionContext.reportGoalAchieved({
                    goalType: DoppeActionGoalType.Click,
                });
                void handleDownloadClick();
            },
            suffixIcon: DoppeViewerAppIconDownloadMedium,
        };
    },
});
